'use client'

type Props = {
  doordashUrl?: string
  uberEatsUrl?: string
  grubhubUrl?: string
  /**
   * ¿El cliente puede pedir delivery PROPIO de Redy en esta página? Ya viene
   * RESUELTO por el servidor — es el `deliveryEnabled` que sale de
   * `redyDeliveryAvailableToCustomer` en `lib/microsite/loadMicrositeData.ts`.
   *
   * ⚠️ NO es `location_delivery_config.enabled`, y NO se puede recalcular acá:
   * la allowlist vive en `REDY_DELIVERY_CUSTOMER_LOCATIONS`, una env sin prefijo
   * `NEXT_PUBLIC_`. En el bundle del navegador esa env no existe, así que llamar
   * al helper desde este componente daría `false` en la hidratación y `true` en
   * el SSR: un no-op con mismatch de hidratación de regalo. Por eso llega como
   * booleano y no como insumo.
   */
  redyDeliveryEnabled?: boolean
  /**
   * `features.module_delivery` del local. Sigue sin plomearse: hoy es `false`
   * por defecto para TODOS los locales y nadie lo setea, así que pasarlo
   * apagaría delivery en todos lados. Queda como override explícito: solo un
   * `false` literal fuerza a mostrar los links igual.
   */
  redyDeliveryModuleEnabled?: boolean
}

export function DeliverySection({
  doordashUrl,
  uberEatsUrl,
  grubhubUrl,
  redyDeliveryEnabled,
  redyDeliveryModuleEnabled,
}: Props) {
  /**
   * Si el cliente puede pedir delivery propio de Redy AQUÍ, estos links sobran:
   * mandarlo a DoorDash le regala al marketplace una comisión del 25 % y la
   * relación con el cliente que el merchant ya tenía.
   *
   * El default sigue cayendo del lado seguro: sin prop, `redyDeliveryEnabled`
   * es `undefined` y los links quedan VISIBLES. Nunca escondemos la única
   * opción de envío del cliente por un prop que alguien olvidó pasar.
   */
  if (redyDeliveryEnabled && redyDeliveryModuleEnabled !== false) return null

  if (!doordashUrl && !uberEatsUrl && !grubhubUrl) return null

  return (
    <section className="py-12 px-4 max-w-5xl mx-auto" style={{ background: 'var(--ms-surface)' }}>
      <h2 className="text-xl font-bold text-center" style={{ color: 'var(--ms-text)' }}>
        También puedes ordenar en:
      </h2>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {doordashUrl && (
          <a
            href={doordashUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-bold text-white transition hover:opacity-90"
            style={{ backgroundColor: '#EB1700' }}
          >
            DoorDash
          </a>
        )}
        {uberEatsUrl && (
          <a
            href={uberEatsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-bold text-white transition hover:opacity-90"
            style={{ backgroundColor: '#000000' }}
          >
            Uber Eats
          </a>
        )}
        {grubhubUrl && (
          <a
            href={grubhubUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-bold text-white transition hover:opacity-90"
            style={{ backgroundColor: '#F63440' }}
          >
            Grubhub
          </a>
        )}
      </div>
    </section>
  )
}
